import template from './template.html'
import controller from './orgSettingsJson.controller'

export default {
  restrict: 'E',
  template,
  bindings: {
    /* thing: '=' */
  },
  controller,
  controllerAs: 'vm',
}
